import { Component } from '@angular/core';

import { of } from 'rxjs';

import { FilesDisplayComponent as FilesDisplayExtendedComponent, FilesUploadComponent } from '@camelot/files-extended';
import { Menu } from '@camelot/menu';
import { EFileExtension, FileData, FileType } from '@camelot/utils';

import { TestIdDirective } from '@camelot/testing-harness';

const fileDataMock: FileData = {
  fileExtension: EFileExtension.Image,
  id: 1,
  name: 'picture.png',
  type: 'Image',
  url: 'https://mock.local/picture.png',
};

@Component({
    imports: [FilesDisplayExtendedComponent, FilesUploadComponent, TestIdDirective],
    template: `
    <cam-files-display
      camTestId="cam-files-display-extended"
      [files$]="this.files$"
      [menu]="this.menu"
      [fileType]="this.fileType"
    />
    <cam-files-upload camTestId="cam-files-upload" [features]="this.features" />
  `
})
export class FilesExtendedCase {
  public features = ['upload-file' as const];
  public files$ = of([fileDataMock]);
  public fileType: FileType = 'Image';
  public menu = new Menu();
}
